import EntityFormPresenter, {
  EntityFormData,
  EntityFormPresenterProps,
} from './EntityFormPresenter';

export default EntityFormPresenter;

export type { EntityFormData, EntityFormPresenterProps };
